import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Job {
  name: string;
  path: string;
  type: string;
  schedule: string;
}

@Injectable({
  providedIn: 'root'
})
export class JobsService {
  constructor(private http: HttpClient) {}

  public load = (teamName: string): Observable<Job[]> =>
    this.http.get<Job[]>(`${ConfigService.apiUrl}/jobs/${teamName}`);

  public setSchedule = (teamName: string, path: string, schedule: string): Observable<any> =>
    this.http.post(`${ConfigService.apiUrl}/jobs/${teamName}/schedule`, { path, schedule });

  public delete = (teamName: string, path: string): Observable<any> =>
    this.http.delete(`${ConfigService.apiUrl}/jobs/${teamName}`, { body: { path } });
}
